
// Step2Component.tsx
import React from "react";
import { Button } from "@shared/ui/button";
import { Input } from "@shared/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { UploadIcon, Loader2 } from "lucide-react";

interface Step2Props {
  handleFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isValidating: boolean;
  uploadedFile: File | null;
  setStep: (step: number) => void;
}

export const Step2Component: React.FC<Step2Props> = ({
  handleFileUpload,
  isValidating,
  uploadedFile,
  setStep,
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Step 2: Upload Completed Template</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
            {isValidating ? (
              <div className="space-y-4">
                <Loader2 className="w-12 h-12 mx-auto text-blue-500 animate-spin" />
                <div>
                  <p className="text-lg font-medium">Validating your file...</p>
                  <p className="text-gray-500">
                    Please wait while we process your data
                  </p>
                </div>
              </div>
            ) : (
              <>
                <UploadIcon className="w-12 h-12 mx-auto text-gray-400 mb-4" />
                <div className="space-y-2">
                  <p className="text-lg font-medium">Upload your completed CSV file</p>
                  <p className="text-gray-500">
                    Select the template file you filled with your data
                  </p>
                  <Input
                    type="file"
                    accept=".csv"
                    onChange={handleFileUpload}
                    className="mt-4"
                    disabled={isValidating}
                  />
                </div>
              </>
            )}
          </div>
          {uploadedFile && !isValidating && (
            <div className="bg-blue-50 p-4 rounded-lg mt-4">
              <p className="font-medium">File uploaded: {uploadedFile.name}</p>
              <p className="text-sm text-gray-600">
                File validation completed successfully
              </p>
            </div>
          )}
        </CardContent>
      </Card>
      <div className="flex justify-between">
        <Button variant="outline" onClick={() => setStep(1)} disabled={isValidating}>
          Back
        </Button>
      </div>
    </div>
  );
};